import { ApiError } from "@/shared/api/http-client";

/**
 * Translation key for a failed invitations read. 429 (the endpoint is
 * throttled to 20/min) and 403 get their own copy (a 401 that survived the forced
 * token refresh is not a permission problem, so it reads as generic); everything else is the
 * generic one. Never surfaces the server message or body: the response may
 * echo request details and the list carries PII.
 */
export function invitationsErrorKey(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return "invitations.errors.rateLimited";
    if (error.status === 403) return "invitations.errors.forbidden";
  }
  return "invitations.errors.generic";
}
